import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-redux-form/immutable'
import { Fieldset } from 'react-gridforms'
import Modal from 'bisu-react-modal'
import RowSearch from 'bisu-react-row-search'

import FieldGroupRow from 'components/FieldGroupRow'
import { intRequired, required } from 'utils/validators'

import { addFee } from './actions'

const validators = {
  fee_id: { intRequired },
  amount: { required },
}

class FormAddFee extends Component {

  _onSubmit = (payload) => {
    const { dispatch, handleClose, studentID } = this.props
    dispatch(addFee(studentID, payload))
      .then((res) => {
        if (!res.error) {
          handleClose()
        }
      })
  }

  render() {
    const { pending, __fees, isOpen, handleClose } = this.props

    return (
      <Modal isOpen={isOpen} handleClose={handleClose}>
        <Form model="feeFormState" onSubmit={this._onSubmit} className="grid-form" validators={validators}>
          <Fieldset legend="Add Fee">
            <RowSearch
              placeholder="Search Fee Code"
              label1="Fee Code"
              label2="Fee Name"
              model="feeFormState.fee_id"
              model1="feeFormState.fee_code"
              model2="feeFormState.fee_name"
              searchResults={__fees}
              autoFocus
              required
              isOffline
            />
            <FieldGroupRow
              model=".amount"
              label="Amount (Php)"
              required
            />
          </Fieldset>
          <fieldset className="modal-footer" disabled={pending}>
            <button type="submit" className="btn btn-success">Add Fee</button>
          </fieldset>
        </Form>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    __fees: state.fee.get('list'),
  }
}

export default connect(mapStateToProps)(FormAddFee)



// WEBPACK FOOTER //
// ./src/containers/Billing/form-add-fee.js